import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/countdownTimerApi";
import '../../../../assets/css/app-countdown-timer-module.css';
import '../../../../assets/css/loader.css'; 

//Import Widgets
import DynamicTemplate from "../../../../components/Apps/CountdownTimer/Template/DynamicTemplate";

//Import Tabs
import TimerTab from "../../../../components/Apps/CountdownTimer/TimerTab";
import ButtonTab from "../../../../components/Apps/CountdownTimer/ButtonTab";
import AppearanceTab from "../../../../components/Apps/CountdownTimer/AppearanceTab";

export default function CreateCountdownTimer() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    //const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Timer");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Countdown Timer");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Get today's date in "YYYY-MM-DD" format
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];

    // Get end date (30 days from today) in "YYYY-MM-DD" format
    const endDate = new Date();
    endDate.setDate(today.getDate() + 30);
    const formattedEndDate = endDate.toISOString().split('T')[0];

    const [countdownTimerTabData, setCountdownTimerTabData] = useState({
        is_website_frontend: "", 
        timer_type: "",    
        timer_start_date: formattedToday,    
        timer_start_time: "12:00 AM",      
        timer_end_date: formattedEndDate, 
        timer_end_time: "12:00 AM",     
        timer_time_zone: "",    
        timer_position_type: "",   
        timer_message_before_timer: "⚡️ Limited-time offer! Sale ends in 1",    
        timer_counters_labels_displays_count: ["Days", "Hours", "Minutes", "Seconds"],    
        timer_days_label: "Days",    
        timer_hours_label: "Hours",    
        timer_minutes_label: "Minutes",    
        timer_seconds_label: "Seconds",   
        timer_action_after_timer_select_action: "",    
        timer_timer_align: "",    
        button_is_show_button: 1,    
        button_link: "https://dashboard.upgadeify.com",    
        button_text: "Shop Now",    
        button_is_open_link_in_new_tab: 1,    
        button_is_make_the_whole_timer_clickable: "",    
        appearance_style: "",    
        appearance_holiday_theme: "",    
        appearance_colors_timer_color: "#5A5AFF",    
        appearance_colors_labels_color: "#fff",    
        appearance_colors_message_color: "#000",    
        appearance_colors_button_color: "#f7e900",    
        appearance_colors_background_color: "#fff",    
        appearance_message_font_size: "24px",    
        appearance_timer_size: "20",    
        appearance_button_size: "20",    
        appearance_animation_type: "",    
        appearance_custom_css: "",    
        appearance_custom_js: "",
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open"); 
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateCountdownTimerTabData = (key, value) => {
        setCountdownTimerTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Timer", icon: "timer.png", label: "Timer" },
        { key: "Button", icon: "button.png", label: "Button" },
        { key: "Appearance", icon: "appearance.png", label: "Appearance" },
    ];
    
    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setCountdownTimerTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setCountdownTimerTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(countdownTimerTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/countdown-timer');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/countdown-timer/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Timer" && (
                        <TimerTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData} />
                    )}
                    {activeSection === "Button" && (
                        <ButtonTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData} />
                    )}
                    {activeSection === "Appearance" && (
                        <AppearanceTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/countdown-timer"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/timer-color.svg`} alt="app-icon-2"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/countdown-timer/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/countdown-timer" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Countdown Timer <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Countdown_Timer_Temp" && (
                      <DynamicTemplate selectedTemplate="Countdown_Timer_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Black_Friday_Sale_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Black_Friday_Sale_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Special_Offer_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Special_Offer_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Urgency_Countdown_Temp" && (
                      <DynamicTemplate selectedTemplate="Urgency_Countdown_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Event_Start_Countdown_Temp" && (
                      <DynamicTemplate selectedTemplate="Event_Start_Countdown_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Limited_Shipping_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Limited_Shipping_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 